import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthRepositoryPort } from '../domain/repositories/auth.repository.port';
import { AuthRepository } from './repositories/auth.repository';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HttpLoadingInterceptor } from './interceptors/http-loading.interceptor';

export const AUTH_PROVIDERS: Provider[] = [
  {
    provide: AuthRepositoryPort,
    useClass: AuthRepository,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpLoadingInterceptor,
    multi: true,
  },
];
